import React from "react";
import { cn } from "@/lib/utils";

/**
 * GlowOrb — soft ambient color orb for backdrops.
 * Use absolute-positioning props or className to place it.
 *
 *   <GlowOrb color="purple" size={520} className="-top-40 -left-40" />
 */
const GlowOrb = ({
  color = "purple",
  size = 480,
  opacity = 0.40,
  className = "",
  style = {},
}) => {
  const colorClass =
    color === "cyan"   ? "glow-orb-cyan"   :
    color === "indigo" ? "glow-orb-indigo" :
                         "glow-orb-purple";

  return (
    <div
      aria-hidden="true"
      className={cn("glow-orb", colorClass, className)}
      style={{
        width: size,
        height: size,
        opacity,
        ...style,
      }}
    />
  );
};

export default GlowOrb;
